/* @flow */

import * as types from 'src/shared/app/chat/action/uiChatActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {
  isPhoneNumberModalShown: false,
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const togglePhoneNumberModal = (state: Object): Object => ({
  ...state,
  isPhoneNumberModalShown: !state.isPhoneNumberModalShown,
});

export default createReducer(initialState, {
  [types.OPEN_PHONE_NUMBER_MODAL]: togglePhoneNumberModal,
  [types.CLOSE_PHONE_NUMBER_MODAL]: togglePhoneNumberModal,
});
